import type { SedrFile } from '../../api/sedr';
import { fileTypeLabelKeyFor } from '../../files/fileTypes';
import { applyI18n, t } from '../../i18n';
import { dialogHelpTopic } from '../../help/dialogHelpTopics';
import { bindModalDismiss, createModalShell } from '../../ui/modalDialogShell';
import { formatSedrDate, formatSedrDateTime } from './sedrUi';
import { sedrFolderCrumbs } from './sedrEvidenceExplorer';

function escapeHtml(value: string): string {
  return value
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;');
}

export function showSedrFilePropertiesDialog(input: {
  file: SedrFile;
  files: SedrFile[];
  formatSize: (bytes: number) => string;
}): void {
  const shell = createModalShell({
    titleKey: 'files.owner.properties',
    helpTopic: dialogHelpTopic('sedrProperties'),
    className: 'files-properties-dialog',
  });

  const crumbs = sedrFolderCrumbs(input.files, input.file.parentId ?? null);
  const location = crumbs.length === 0 ? '/' : `/${crumbs.map((c) => c.name).join('/')}`;
  const typeLabel = input.file.isDirectory
    ? t('files.owner.folderType')
    : t(fileTypeLabelKeyFor(input.file.name, input.file.contentType));
  const sizeMarkup =
    !input.file.isDirectory && input.file.sizeBytes != null
      ? `<dt data-i18n="files.owner.fileSize"></dt><dd>${escapeHtml(input.formatSize(input.file.sizeBytes))}</dd>`
      : '';

  shell.body.innerHTML = `
    <dl class="files-properties-dialog__grid">
      <dt data-i18n="files.owner.fileName"></dt>
      <dd>${escapeHtml(input.file.name)}</dd>
      <dt data-i18n="files.owner.propertiesType"></dt>
      <dd>${escapeHtml(typeLabel)}</dd>
      <dt data-i18n="files.owner.propertiesLocation"></dt>
      <dd>${escapeHtml(location)}</dd>
      ${sizeMarkup}
      <dt data-i18n="files.owner.propertiesCreatedAt"></dt>
      <dd>${escapeHtml(formatSedrDateTime(input.file.createdAt) || formatSedrDate(input.file.createdAt))}</dd>
    </dl>
  `;

  document.body.append(shell.backdrop);
  applyI18n(shell.dialog);

  const close = () => {
    unbindDismiss();
    shell.backdrop.remove();
  };

  const unbindDismiss = bindModalDismiss({
    backdrop: shell.backdrop,
    closeButton: shell.closeButton,
    onClose: close,
  });
}
